import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

document.querySelectorAll(".element-whyjamaica").forEach((el) => {
  const svg = el.querySelector(".why-jamaica-svg");

  if (!svg) {
    return;
  }

  const plane = svg.querySelector(".plane");
  const path = svg.querySelector(".plane-path");

  const svgNS = "http://www.w3.org/2000/svg";
  const pathLength = path.getTotalLength();

  const dashLength = 14;
  const gapLength = 7;

  let currentLength = 0;

  while (currentLength < pathLength) {
    const dashPath = document.createElementNS(svgNS, "path");
    dashPath.setAttribute("class", "plane-path-dash");
    dashPath.setAttribute("stroke", "#BFBFBF");
    dashPath.setAttribute("stroke-width", "1");
    dashPath.setAttribute("fill", "none");

    let start = path.getPointAtLength(currentLength);
    currentLength += dashLength;

    if (currentLength > pathLength) {
      currentLength = pathLength;
    }

    let end = path.getPointAtLength(currentLength);

    dashPath.setAttribute("d", `M ${start.x} ${start.y} L ${end.x} ${end.y}`);

    svg.insertBefore(dashPath, plane);

    currentLength += gapLength;
  }

  const dashes = svg.querySelectorAll(".plane-path-dash");

  gsap.set(dashes, { opacity: 0 });

  gsap
    .timeline({
      scrollTrigger: {
        trigger: el,
        markers: false,
        start: "top center",
      },
    })
    .to(dashes, {
      opacity: 1,
      stagger: 0.05,
    })
    .to(
      plane,
      {
        motionPath: {
          path: "M588 1c180.96 34.935 361.92 200.297 416 361",
          autoRotate: true,
          offsetX: 15,
          offsetY: -11,
        },
        duration: 3,
      },
      "<60%",
    );
});
